import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-login"
  }, [_c("img", {
    staticClass: "page-login-bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567702137.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "top"
  }, [_c("router-link", {
    staticClass: "header",
    staticStyle: {
      left: "auto",
      right: "20px"
    },
    attrs: {
      to: "/index"
    }
  }, [_c("img", {
    staticClass: "icon",
    attrs: {
      src: require("./image/workshop/logo.png"),
      alt: ""
    }
  }), _c("div", [_vm._v("智慧渔业管控平台")])]), _c("div", {
    staticClass: "right"
  }, [_vm._m(0), _c("div", {
    staticClass: "item"
  }, [_vm._m(1), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("温度")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.weatherData.temp) + " "), _c("span", [_vm._v("℃")])])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(2), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("湿度")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.weatherData.rh) + " "), _c("span", [_vm._v("%")])])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(3), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("风力")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value",
    staticStyle: {
      "font-size": "0.9vw"
    }
  }, [_vm._v(_vm._s(_vm.weatherData.wind_class))])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(4), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("风向")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value",
    staticStyle: {
      "font-size": "0.9vw"
    }
  }, [_vm._v(_vm._s(_vm.weatherData.wind_dir))])]), _c("div", {
    staticClass: "line"
  })]), _c("div", {
    staticClass: "item"
  }, [_vm._m(5), _c("div", {
    staticClass: "item-content"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("天气")]), _c("img", {
    attrs: {
      src: require("./image/workshop/icon-line.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "value",
    staticStyle: {
      "font-size": "0.9vw"
    }
  }, [_vm._v(_vm._s(_vm.weatherData.text))])]), _c("div", {
    staticClass: "line"
  })])])], 1), _c("div", {
    staticClass: "center"
  }, [_c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside1.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "center-content"
  }, _vm._l(_vm.structures_list, function (item, index) {
    return _c("div", {
      key: item.id,
      staticClass: "item"
    }, [_c("div", {
      staticClass: "item-header"
    }, [_c("img", {
      attrs: {
        src: require("./image/workshop/item-header.png"),
        alt: ""
      }
    }), _c("div", [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _c("div", {
      staticClass: "breed"
    }, [_vm._v(" 品种：" + _vm._s(item.farmedSpecies || "--") + " ")])])]), _c("div", {
      staticClass: "item-content"
    }, [_c("div", {
      staticClass: "data-1"
    }, _vm._l(item.lastRecord, function (opt, idx) {
      return _c("div", {
        key: idx,
        staticClass: "data-info"
      }, [_c("div", {
        staticClass: "title"
      }, [_c("div", {
        staticClass: "line"
      }), _c("div", {
        staticClass: "title-left"
      }, [_c("div", [_c("div", [_vm._v(_vm._s(opt.itemName))])]), _c("div", {
        staticClass: "value"
      }, [_c("div", {
        staticClass: "number",
        class: {
          "level-1": item.level[idx] == "优",
          "level-2": item.level[idx] == "良",
          "level-3": item.level[idx] == "中",
          "level-4": item.level[idx] == "差"
        }
      }, [_vm._v(_vm._s(opt.itemValue))]), _c("span", {
        staticClass: "unit"
      }, [_vm._v(_vm._s(opt.itemUnit))])])])])]);
    }), 0), _c("div", {
      staticClass: "data-2"
    }, [_c("div", {
      staticClass: "view"
    }, [_c("div", {
      staticStyle: {
        width: "100%",
        height: "100%"
      }
    }, [1 ? _c("img", {
      staticStyle: {
        width: "100%",
        height: "100%"
      },
      attrs: {
        src: require("./image/largeWater/video-block.png"),
        alt: ""
      }
    }) : _c("m3u8Video", {
      attrs: {
        id: item.videoId
      }
    })], 1)]), _c("div", {
      staticClass: "chart"
    }, [_c("itemLogsLineChart", {
      attrs: {
        data: item.itemLog,
        items: item.items,
        index: index
      }
    })], 1)])])]);
  }), 0), _c("img", {
    staticClass: "aside-img",
    attrs: {
      src: require("./image/workshop/aside2.png"),
      alt: ""
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "level"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v("[水质等级]")]), _c("div", {
    staticClass: "levels"
  }, [_c("div", {
    staticClass: "level-1"
  }, [_vm._v("优")]), _c("div", {
    staticClass: "level-2"
  }, [_vm._v("良")]), _c("div", {
    staticClass: "level-3"
  }, [_vm._v("中")]), _c("div", {
    staticClass: "level-4"
  }, [_vm._v("差")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/RoomTemperature.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/RoomHumidity.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/fl.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/fx.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon"
  }, [_c("img", {
    staticClass: "bg",
    attrs: {
      src: "https://ossgy.rich-link.cn/1705212595702325248/20250530/1748567944863.png",
      alt: ""
    }
  }), _c("img", {
    staticClass: "img",
    attrs: {
      src: require("./image/workshop/RoomIllumination.png"),
      alt: ""
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };